const ManufacturerTableParser = {};

ManufacturerTableParser.getManufacturerTableParser = (res) => {
  if (res) {
    res = res?.result?.reverse();
    return res;
  }

  if (!res) {
    return {};
  }
};
ManufacturerTableParser.postAddManufacturerParser = (res) => {
  if (res) {
    res = res.result;
  }

  if (!res) {
    return {};
  }
};

ManufacturerTableParser.getAddManufacturerTableParser = (res) => {
  if (res) {
    res = res?.result?.reverse();
    return res;
  }

  if (!res) {
    return {};
  }
};

ManufacturerTableParser.getAddConnectorParser = (res) => {
  if (res) {
    res = res?.result?.reverse();
    return res;
  }

  if (!res) {
    return {};
  }
};

ManufacturerTableParser.getAddVehicleVariantParser = (res) => {
  if (res) {
    res = res?.result?.reverse();
    return res;
  }

  if (!res) {
    return {};
  }
};

export { ManufacturerTableParser };
